import { render, staticRenderFns } from "./PreviewCheckbox.vue?vue&type=template&id=001a08e4&"
import script from "./PreviewCheckbox.vue?vue&type=script&lang=js&"
export * from "./PreviewCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports